// actionLabels.js
export const FETCH_INVOICE_DETAILS_REQUEST = 'FETCH_INVOICE_DETAILS_REQUEST';
export const FETCH_INVOICE_DETAILS_SUCCESS = 'FETCH_INVOICE_DETAILS_SUCCESS';
export const FETCH_INVOICE_DETAILS_FAILURE = 'FETCH_INVOICE_DETAILS_FAILURE';
 
// fetch invoice by id
export const FETCH_INVOICE_DETAILS_ID_REQUEST = "FETCH_INVOICE_DETAILS_ID_REQUEST";
export const FETCH_INVOICE_DETAILS_ID_SUCCESS = "FETCH_INVOICE_DETAILS_ID_SUCCESS";
export const FETCH_INVOICE_DETAILS_ID_FAILURE = "FETCH_INVOICE_DETAILS_ID_FAILURE";

// create invoice
export const ADD_INVOICE_DETAILS_REQUEST = "ADD_INVOICE_DETAILS_REQUEST";
export const ADD_INVOICE_DETAILS_SUCCESS = "ADD_INVOICE_DETAILS_SUCCESS";
export const ADD_INVOICE_DETAILS_FAILURE = "ADD_INVOICE_DETAILS_FAILURE";

// update invoice
export const UPDATE_INVOICE_DETAILS_REQUEST = "UPDATE_INVOICE_DETAILS_REQUEST";
export const UPDATE_INVOICE_DETAILS_SUCCESS = "UPDATE_INVOICE_DETAILS_SUCCESS";
export const UPDATE_INVOICE_DETAILS_FAILURE = "UPDATE_INVOICE_DETAILS_FAILURE";

// delete invoice
export const DELETE_INVOICE_DETAILS_REQUEST = "DELETE_INVOICE_DETAILS_REQUEST";
export const DELETE_INVOICE_DETAILS_SUCCESS = "DELETE_INVOICE_DETAILS_SUCCESS";
export const DELETE_INVOICE_DETAILS_FAILURE = "DELETE_INVOICE_DETAILS_FAILURE";
